/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Save_Aborted_ToastInputs */



/**
* | output |
* | --- |
* | "Save cancelled" |
*
* @param {Standards_Preset_Save_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_aborted_toast = /** @type {((inputs?: Standards_Preset_Save_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save cancelled")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save cancelled")
	return /** @type {LocalizedString} */ ("Save cancelled")
});